module.exports = __webpack_public_path__ + "static/img/YAMAHA.9132bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/YAMAHA.png
// module id = blrS
// module chunks = 1